import { render, staticRenderFns } from "./MandateDeleteDialog.vue?vue&type=template&id=e855f864&"
import script from "./MandateDeleteDialog.vue?vue&type=script&lang=js&"
export * from "./MandateDeleteDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports